export default "__VITE_PUBLIC_ASSET__40d20f27__"